<script setup lang="ts">
import MenuLink from '@app/layout/nav/mobile/components/MenuLink.vue';
import { URL_HOME, URL_SEARCH } from '@tools/routes/routes';
import { trans } from '@tools/translation.ts';
import IconMagnifyingGlass from '@icons/ph_magnifying-glass.svg';
import IconHouse from '@icons/ph_house.svg';
import IconUserCircle from '@icons/ph_user-circle.svg';
import Icon from '@components/Icon.vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import Button from '@components/Button.vue';

const { openLoginModal } = useNavbarStore();
</script>

<template>
  <li>
    <MenuLink :link="URL_HOME">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconHouse"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.home') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink :link="URL_SEARCH">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconMagnifyingGlass"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.search') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <Button
      variant="invisible"
      :class="[
        '!border-0',
        '!p-0',
        'hover:!bg-transparent'
      ]"
      data-cy-ref="navbar-mobile__btn--login"
      @click="openLoginModal"
    >
      <MenuLink>
        <template #icon="{ isActive }">
          <Icon
            :svg="IconUserCircle"
            width="24"
            height="24"
            :fill="isActive ? 'blue' : 'gray-darker'"
          />
        </template>

        <template #text>
          {{ trans('user_menu.login') }}
        </template>
      </MenuLink>
    </Button>
  </li>
</template>
